import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { DropdownButton, Dropdown, Container, NavDropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import FuelSaveGlobalContext from '../../context/FuelSaveGlobalContext'
import ACTIONS from '../../utils/action'
import Icon from './Icons'
import { handleRequest } from '../../constant/helpers'
import { setProjectInfo, setProjectIsProcessing } from '../../actions/project'


const NavBarLogin = ({ logoutCallback, user }) => {
    const { projects } = useSelector(state => state.projects)
    const dispatch = useDispatch()
    const {
        projectNumberDispatch,
        globalProjectName, projectNameDispatch,
        globalBrandCrumb,
        navSideBarOpen
    } = useContext(FuelSaveGlobalContext);
    const { t } = useTranslation();

    const getProjectById = async (id) => {
        try {
            dispatch(setProjectIsProcessing(true))
            const data = await handleRequest("post", false, {
                query: `
                    query{
                        projects(project_ids:${id}){
                          project_name
                          project_id,
                          start_year,
                          end_year
                        }
                      }`
            })
            dispatch(setProjectIsProcessing(false))
            if (!!data && !!data.data && !!data.data.data && !!data.data.data.projects) {
                const resp = data.data.data.projects
                localStorage.setItem('selectedProject', JSON.stringify(resp[0]))
                dispatch(setProjectInfo(resp[0]))
                projectNameDispatch({ type: ACTIONS.PROJECT_NAME_CHANGE, payload: resp[0].project_name });
                projectNumberDispatch({ type: ACTIONS.PROJECT_NAME_CHANGE, payload: resp[0].project_id });
                return resp
            }
            return []
        } catch (e) {
            dispatch(setProjectIsProcessing(false))
            console.log('getProjectById Error: ', e)
            return e
        }
    }

    return (
        <Container fluid style={{ background: "#ffffff", position: 'fixed', top: '0', height: 97, zIndex: 9 }}>
            <div className='h-100 between-flex'>
                <div className={`navbar-heading-${navSideBarOpen ? 'small' : 'large'}`} >
                    <p style={{ margin: 0, float: 'right', fontSize: 30, fontWeight: 'bold', marginRight: navSideBarOpen ? 0 : 95 }}>{globalBrandCrumb}</p>
                </div >
                <div className='f-end-flex'>
                    <div className='d-flex ai-center'>
                        <DropdownButton
                            title={globalProjectName}
                            id="nav-project-dd"
                            onSelect={getProjectById}
                            size="lg"
                            className="f-left"
                        >
                            {projects ? projects.map((name) => (
                                <Dropdown.Item key={name.project_id} eventKey={name.project_id}>{name.project_name}</Dropdown.Item>
                            )) : null}
                        </DropdownButton>
                        <NavDropdown id="accountNav" className="navbar-nav open-left" title={<><Icon name='user' style={{ marginRight: 10 }} /> {user}</>}>
                            <NavDropdown.Item onClick={() => window.open(require('./manual.pdf').default, "_blank")}>
                                {t('User Manual')}
                            </NavDropdown.Item>
                            <NavDropdown.Item onSelect={logoutCallback}>
                                {t('Logout')}
                            </NavDropdown.Item>
                        </NavDropdown>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default NavBarLogin